import { ServiceStoreConfig } from "../types/ServiceStoreTypes";

/**
 * User Module Service Stores
 */
export const userStores: ServiceStoreConfig[] = [
  {
    name: "users",
    options: {
      enableStorage: true,
      enableErrorNotifications: true,
      serviceView: {
        enableServiceView: true,
        summaryCards: (rootStore) => {
          const store = rootStore.usersStore as { entities?: unknown[] };
          const entities = store?.entities || [];
          const totalUsers = entities.length;
          const activeUsers = entities.filter(
            (user: Record<string, unknown>) =>
              user.isActive || user.status === "active"
          ).length;
          const adminUsers = entities.filter(
            (user: Record<string, unknown>) =>
              user.role === "admin" || user.isAdmin
          ).length;
          const onlineUsers = entities.filter(
            (user: Record<string, unknown>) =>
              user.isOnline || user.status === "online"
          ).length;

          return [
            {
              title: "Total Users",
              value: () => totalUsers.toString(),
              valueColor: "primary.main",
            },
            {
              title: "Active",
              value: () => activeUsers.toString(),
              valueColor: "success.main",
            },
            {
              title: "Admins",
              value: () => adminUsers.toString(),
              valueColor: "warning.main",
            },
            {
              title: "Online Now",
              value: () => onlineUsers.toString(),
              valueColor: "info.main",
            },
          ];
        },
        permissions: {
          requiresAuth: true,
          requiresAdmin: true,
        },
      },
    },
  },
  {
    name: "engineers",
    options: {
      enableStorage: true,
      enableErrorNotifications: true,
      serviceView: {
        enableServiceView: true,
        summaryCards: (rootStore) => {
          const store = rootStore.engineersStore as { entities?: unknown[] };
          const entities = store?.entities || [];
          const totalEngineers = entities.length;
          const availableEngineers = entities.filter(
            (engineer: Record<string, unknown>) =>
              engineer.status === "available" || !engineer.assigned
          ).length;
          const busyEngineers = entities.filter(
            (engineer: Record<string, unknown>) =>
              engineer.status === "busy" || engineer.assigned
          ).length;
          const seniorEngineers = entities.filter(
            (engineer: Record<string, unknown>) =>
              engineer.level === "senior" ||
              (engineer.years_experience as number) > 5
          ).length;

          return [
            {
              title: "Total Engineers",
              value: () => totalEngineers.toString(),
              valueColor: "primary.main",
            },
            {
              title: "Available",
              value: () => availableEngineers.toString(),
              valueColor: "success.main",
            },
            {
              title: "Busy",
              value: () => busyEngineers.toString(),
              valueColor: "warning.main",
            },
            {
              title: "Senior",
              value: () => seniorEngineers.toString(),
              valueColor: "info.main",
            },
          ];
        },
        permissions: {
          requiresAuth: true,
          requiresAdmin: false,
        },
      },
    },
  },
  // New backend services
  {
    name: "user-certifications",
    options: {
      enableStorage: true,
      enableErrorNotifications: true,
      idField: "id",
    },
  },
  {
    name: "user-training",
    options: {
      enableStorage: true,
      enableErrorNotifications: true,
      idField: "id",
    },
  },
];